{
    "tenants": {
        "title": "Leietakere",
		"addTenant": "Legg til leietaker",
		"companyName": "Firmanavn",
		"tenantAlias": "Leietakeralias",
		"email": "E-post",
		"tier": "Nivå",
		"status": "Status",
		"type": "Type",
		"address": "Adresse",
		"phone": "Telefon",
		"adminEmail": "Administrator-e-post",
		"billingEmail": "Fakturerings-e-post",
		"tenantType": "Leietakertype",
		"tenantApps": "Leietakerapper",
		"tenantLabel": "Leietaker",
		"smsMfa": "SMS MFA",
		"newTenant": "Ny leietaker",
		"editTenant": "Rediger leietaker",
        "active": "Aktiv",
		"inactive": "Inaktiv",
		"enabled": "Aktivert",
		"disabled": "Deaktivert",
        "tenantUsers": "Leietakerbrukere",
        "validation": {
            "companyNameRequired": "Firmanavn kreves",
            "addressRequired": "Adresse kreves",
            "addressMaxLength": "Adressen må ikke overstige 100 tegn",
            "phoneRequired": "Telefon kreves",
            "phoneInvalid": "Vennligst oppgi et gyldig telefonnummer",
            "adminEmailRequired": "Administratorens e-post kreves",
            "adminEmailInvalid": "Vennligst oppgi en gyldig administrator-e-post",
            "billingEmailInvalid": "Vennligst oppgi en gyldig faktura-e-post",
            "billingEmailRequired": "Faktura-e-post kreves",
			"tierRequired": "Nivå kreves",
			"tenantTypeRequired": "Leietakertype kreves",
			"dedicatedIpHostnameRequired": "Vertsnavn kreves når dedikert IP er aktivert",
			"dedicatedIpHostnameInvalid": "Vennligst oppgi et gyldig vertsnavn (f.eks. eu-west-dedicated-02.quotaguard.com)",
			"dedicatedIpEgressIpRequired": "Utgående IP kreves når dedikert IP er aktivert",
			"dedicatedIpEgressIpInvalid": "Vennligst oppgi en gyldig IPv4-adresse (f.eks. 192.168.1.1)",
			"dedicatedIpUsernameRequired": "Brukernavn kreves når dedikert IP er aktivert",
			"dedicatedIpPasswordRequired": "Passord kreves når dedikert IP er aktivert",
			"dedicatedIpPortRequired": "Port kreves når dedikert IP er aktivert",
			"dedicatedIpPortInvalid": "Vennligst oppgi et gyldig portnummer (1–65535)",
			"dedicatedIpProtocolRequired": "Protokoll kreves",
			"dedicatedIpProtocolDuplicate": "Protokoll må være unik for hver port"
        },
		"options": {
			"manageTenant": "Administrer leietaker",
			"manageTenantUsers": "Administrer leietakerbrukere",
			"promoteToAdmin": "Forfrem til Live Admin",
			"adminRoleNoActions": "Admin-rolle — ingen handlinger tilgjengelig",
			"reindexEntities": "Re-indekser entiteter"
		},
		"messages": {
            "loadError": "Feil ved lasting av leietakerddata",
			"deactivateTenantConfirmation": "Er du sikker på at du vil deaktivere leietaker '{tenantName}'?",
			"statusUpdateSuccess": "Leietakerstatus oppdatert",
			"statusUpdateError": "Feil ved oppdatering av leietakerstatus",
			"saveSuccess": "Leietakerdetaljer lagres. Dette kan ta et øyeblikk…",
			"saveError": "Feil ved lagring av leietakerdetaljer",
			"tenantUserGroupUpdated": "Brukergruppe oppdatert",
			"tenantUserGroupUpdateError": "Feil ved oppdatering av brukergruppe",
            "confirmPromoteToAdmin": "Er du sikker på at du vil forfremme {user} til Admin?",
			"reindexSuccess": "Re-indeksering startet for {count} entiteter",
			"reindexError": "Feil ved start av re-indeksering"
		},
		"reindex": {
			"title": "Re-indekser entiteter",
			"description": "Velg en entitetstype å re-indeksere for leietaker '{tenantName}'.",
			"selectEntity": "Velg en entitet",
			"confirm": "Re-indekser"
		},
		"dedicatedIp": {
			"title": "Dedikerte IP-er",
			"enable": "Bruk dedikert IP",
			"proxyHostname": "Proxy-vertsnavn",
			"port": "Port",
			"listeningPorts": "Lytteporter",
			"selectService": "Velg protokoll",
			"username": "Brukernavn",
			"usernamePlaceholder": "proxy-username",
			"password": "Passord",
			"passwordPlaceholder": "••••••••",
			"passwordSet": "Passord er satt ✓",
			"passwordChangePlaceholder": "La stå tom for å beholde eksisterende passord",
			"egressIp1": "Utgående IP 1",
			"egressIp2": "Utgående IP 2"
		},
		"tenantTypes": {
			"SYSADMIN": "Live Admin",
			"TENANT": "Leietaker Admin"
		},
		"tiers": {
			"FREE": "Gratis",
			"ENTERPRISE": "Bedrift",
			"PRO": "Pro"
		},
		"resource": {
			"tenant": "Leietaker"
		}
    }
}
